import { FieldMessage as ChordsFieldMessage } from '~/chords/FieldMessage';

import { withClassNameHoc } from '../WithClassNameHoc';

export const FieldMessage = withClassNameHoc(ChordsFieldMessage);
